import React from "react"
import styles from "./Button.module.scss"

const ButtonSmallElongated = (props: any) => {
    return (
        <button
            {...props}
            className={props.outline ? styles.button_small_elongated_gray : styles.button_small_elongated}
        >
            {props.children}
        </button>
    )
}

export default ButtonSmallElongated
